import linkedinSvg from "../linkedin.svg";

export interface TeamMemberProps {
  name: string;
  role: string;
  img: string;
  linkedInLink?: string;
}

const team: TeamMemberProps[] = [
  {
    name: "Nicola Daprà",
    role: "AI products & strategy",
    img: "nico",
    linkedInLink: "https://www.linkedin.com/in/nicola-dapr%C3%A0-2757651b5/",
  },
  {
    name: "Leonardo Fiore",
    role: "Software engineering",
    img: "leo",
    linkedInLink: "https://www.linkedin.com/in/leonardo-fiore-b45840285/",
  },
  {
    name: "Marta Cortesi",
    role: "Graphic & product design",
    img: "marta",
    linkedInLink: "https://www.linkedin.com/in/marta-cortesi/",
  },
  { name: "Andrea Cappelletti", role: "Front-end & communication", img: "cappo" },
];

export function TeamMember(props: TeamMemberProps) {
  return (
    <div className="team-member">
      <img
        className="team-photo"
        src={process.env.PUBLIC_URL + "/team-img/" + props.img + ".png"}
        alt={props.name}
      />
      <div className="team-row">
        <div className="team-name">
          <span>{props.name}</span>
          <span className="team-role">{props.role}</span>
        </div>
        {props.linkedInLink && (
          <a
            className="team-link"
            href={props.linkedInLink}
            target="_blank"
            rel="noreferrer"
            aria-label={`${props.name} on LinkedIn`}
          >
            <img src={linkedinSvg} alt="" />
          </a>
        )}
      </div>
    </div>
  );
}

export function TeamSection() {
  return (
    <section className="team" id="team">
      <div className="section-header">
        <div>
          <span className="eyebrow">04 — TEAM</span>
          <h2>Mathematicians who ship</h2>
        </div>
        <p>Three mathematicians and a digital designer, working directly on every project.</p>
      </div>
      <div className="grid4">
        {team.map((m) => (
          <TeamMember key={m.name} {...m} />
        ))}
      </div>
    </section>
  );
}
